import { createPricingTable, createPricingTableItem } from "../modules/proposalBuilderSections";

export function getInitials(string) {
    var names = string.split(' '),
        initials = names[0].substring(0, 1).toUpperCase();

    if (names.length > 1) {
        initials += names[names.length - 1].substring(0, 1).toUpperCase();
    }
    return initials;
}

const TOKEN_REGEX = /\[(.*?)\]/g

export function safeInt(string) {
    return Number(string.replace("$", "").replace(/,/g, ""));
}

export const isToken = (token) => {
    let resp = false
    if (token) {
        resp = token.toString().match(TOKEN_REGEX) && token.toString().match(TOKEN_REGEX).length == 1
    }
    return resp
}

export const getTokenId = (token) => token?.replace("$", "")?.replace("[", "")?.replace("]", "")


export const defaultSections = ["Pricing Asumptions", "Setup & Installation Fees", "Annual Fee"]


export const defaultTokenList = () =>
    [
        { name: "Plan Assets - Estimated", previewName: "Plan Assets - Estimated", section: "Pricing Asumptions", token: "$[plan_assets]", active: true },
        { name: "Annual Contributions- Estimated", previewName: "Annual Contributions- Estimated", section: "Pricing Asumptions", token: "$[annual_contributions]", active: true },
        { name: "Number of  Participants With Account Balance", previewName: "Number of  Participants With Account Balance", section: "Pricing Asumptions", token: "[participant_count]", active: true },
        { name: "Plan Design & Setup ($[design_fee] + $[install_part]/ppt.)", previewName: "Plan Design & Setup ($[design_fee] + $[install_part]/ppt.)", section: "Setup & Installation Fees", token: "$[installation_fee]", active: true },
        { name: "Plan Document", previewName: "Plan Document", section: "Setup & Installation Fees", token: "$[document_fee]", active: true },
        { name: "3(16) Setup Fees", previewName: "3(16) Setup Fees", section: "Setup & Installation Fees", token: "$[y1-316-inst]", active: true },
        { name: "Participant Annual Charges ($[participant_fee] per ppt. eligible and with account balance)", previewName: "Participant Annual Charges ($[participant_fee] per ppt. eligible and with account balance)", section: "Annual Fee", token: "$[participant_annual_charges]", active: true },
        { name: "Base Annual Administration", previewName: "Base Annual Administration", section: "Annual Fee", token: "$[annual_admin_fee]", active: true },
        { name: "Plan Document Maintenance Service", previewName: "Plan Document Maintenance Service", section: "Annual Fee", token: "$[plan_doc_maintenance]", active: true },
        { name: "3(16) Annual Administration Fee", previewName: "3(16) Annual Administration Fee", section: "Annual Fee", token: "$[y1-316-admin]", active: true },
        { name: "3(16) Participant Fee ($[y1-316-part] per eligible ppt.)", previewName: "3(16) Participant Fee ($[y1-316-part] per eligible ppt.)", section: "Annual Fee", token: "$[p_a_c_3_16]", active: true },
        { name: "Audit Fee", previewName: "Audit Fee", section: "Annual Fee", token: "$[audit_fee]", active: true },
    ]

export const defaultTablePricing = () => {
    const defaultValues = [
        { name: "Plan Assets - Estimated", previewName: "Plan Assets - Estimated", section: "Pricing Asumptions", token: "$[plan_assets]", active: true, errorValue: false, errorDescription: false },
        { name: "Annual Contributions- Estimated", previewName: "Annual Contributions- Estimated", section: "Pricing Asumptions", token: "$[annual_contributions]", active: true, errorValue: false, errorDescription: false },
        { name: "Number of  Participants With Account Balance", previewName: "Number of  Participants With Account Balance", section: "Pricing Asumptions", token: "[participant_count]", active: true, errorValue: false, errorDescription: false },
        { name: "", previewName: "", section: "", token: "", active: true, errorValue: false, errorDescription: false },
        { name: "Plan Design & Setup ($[design_fee] + $[install_part]/ppt.)", previewName: "Plan Design & Setup ($[design_fee] + $[install_part]/ppt.)", section: "Setup & Installation Fees", token: "$[installation_fee]", active: true, errorValue: false, errorDescription: false },
        { name: "Plan Document", previewName: "Plan Document", section: "Setup & Installation Fees", token: "$[document_fee]", active: true, errorValue: false, errorDescription: false },
        { name: "3(16) Setup Fees", previewName: "3(16) Setup Fees", section: "Setup & Installation Fees", token: "$[y1-316-inst]", active: true, errorValue: false, errorDescription: false },
        { name: "", previewName: "", section: "", token: "", active: true, errorValue: false, errorDescription: false },
        { name: "Participant Annual Charges ($[participant_fee] per ppt. eligible and with account balance)", previewName: "Participant Annual Charges ($[participant_fee] per ppt. eligible and with account balance)", section: "Annual Fee", token: "$[participant_annual_charges]", active: true, errorValue: false, errorDescription: false },
        { name: "Base Annual Administration", previewName: "Base Annual Administration", section: "Annual Fee", token: "$[annual_admin_fee]", active: true, errorValue: false, errorDescription: false },
        { name: "Plan Document Maintenance Service", previewName: "Plan Document Maintenance Service", section: "Annual Fee", token: "$[plan_doc_maintenance]", active: true, errorValue: false, errorDescription: false },
        { name: "3(16) Annual Administration Fee", previewName: "3(16) Annual Administration Fee", section: "Annual Fee", token: "$[y1-316-admin]", active: true, errorValue: false, errorDescription: false },
        { name: "3(16) Participant Fee ($[y1-316-part] per eligible ppt.)", previewName: "3(16) Participant Fee ($[y1-316-part] per eligible ppt.)", section: "Annual Fee", token: "$[p_a_c_3_16]", active: true, errorValue: false, errorDescription: false },
        { name: "", previewName: "", section: "", token: "", active: true, errorValue: false, errorDescription: false },
    ]
    return defaultValues.map(v => createPricingTableItem(v))

}

export const defaultPricingTable = (data = {}) => {
    if (!data.entries)
        data.entries = defaultTablePricing()

    return createPricingTable(data)

}


export const addEmptyPricingTableItem = (pricingTable) => {
    const emptyLine = { name: "", previewName: "", section: "", token: "", active: true }
    return pricingTable.entries.push(createPricingTableItem(emptyLine))
}


const updatePricingTableDescription = (item, dataContext) => {
    const newValue = item?.token || ""
    var matches = newValue.match(TOKEN_REGEX);
    let previewName = item.name
    item.errorDescription = false
    if (dataContext && matches) {
        matches.forEach(currentToken => {
            const formmattedCurrentToken = currentToken.replace("[", "").replace("]", "")
            if (formmattedCurrentToken) {
                if (Object.hasOwn(dataContext, formmattedCurrentToken)) {
                    previewName = previewName.replaceAll(currentToken, dataContext[formmattedCurrentToken])
                    if (dataContext[formmattedCurrentToken] == "ERROR") {
                        item.errorDescription = true
                    }
                }

            }
        })
    }
    item.previewName = previewName
}

export const updatePricingTableDescriptions = (pricingTable, dataContext) => {
    pricingTable.entries.map(entry => updatePricingTableDescription(entry, dataContext))
}

export const cleanNumber = (num) => {
    return num ? Number(num.toString().replaceAll("$", "").replaceAll(",", "")) : 0
}

export const updateTableDescription = (item, dataContext) => {
    const newValue = item?.name || ""
    var matches = newValue.match(TOKEN_REGEX);
    let previewName = item.name
    item.errorDescription = false
    if (dataContext && matches && item.name) {
        matches.forEach(currentToken => {
            const formmattedCurrentToken = currentToken.replace("[", "").replace("]", "")
            if (formmattedCurrentToken) {
                if (Object.hasOwn(dataContext, formmattedCurrentToken)) {
                    previewName = previewName.replaceAll(currentToken, dataContext[formmattedCurrentToken])
                    if (dataContext[formmattedCurrentToken] == "ERROR") {
                        item.errorDescription = true
                    }
                }

            }
        })
    }
    item.previewName = previewName
}
const formatter = new Intl.NumberFormat('en-US', {
    maximumFractionDigits: 0
});


const isSameDescription = (pricingTableItem, defaultTableItem) => defaultTableItem.name == pricingTableItem.name && pricingTableItem.section == defaultTableItem.section

const isSameToken = (pricingTableItem, defaultTableItem) => getTokenId(pricingTableItem.token) == getTokenId(defaultTableItem.token)



const evaluateToken = (token, count, context) => {
    if (context[token] && !(context[token] instanceof Object) && isToken(context[token]) && count < Object.keys(context).length) {
        count = count + 1
        return evaluateToken(getTokenId(context[token]), count++, context)
    } else if (count >= Object.keys(context).length) {
        return "ERROR"
    }
    return token == "ERROR" ? "ERROR" : context[getTokenId(token)]
}


export const handleSelectedTokens = (pricingTable, dataContext) => {
    defaultPricingTable().entries.forEach(defaultItem => {
        pricingTable.entries.forEach(item => {
            if (item.token && !isSameToken(item, defaultItem) && isSameDescription(item, defaultItem)) {
                dataContext[getTokenId(defaultItem.token)] = item.token
            }
        })
    })
    Object.keys(dataContext).forEach(key => {
        if (key != "selected_tokens" && dataContext[key] != undefined && !(dataContext[key] instanceof Object) && isToken(dataContext[key])) {
            dataContext[key] = evaluateToken(getTokenId(dataContext[key]), 1, dataContext)
        }
    })
    return dataContext
}

export const updatePricingTablePreviews = (dataContext, pricingTable) => {
    if (pricingTable && pricingTable.entries && dataContext) {
        let newContext = JSON.parse(JSON.stringify(dataContext))
        handleSelectedTokens(pricingTable, newContext)
        pricingTable.entries.forEach(item => {
            updateTableToken(item, newContext)
        })
        pricingTable.entries.forEach(item => {
            updateTableDescription(item, newContext)
        })
        pricingTable.entries = [...pricingTable.entries]
    }
}

const updateTableToken = (item, dataContext) => {

    const newValue = item?.token || ""
    var matches = newValue.match(TOKEN_REGEX);
    let previewValue = item.token
    item.errorValue = false
    if (dataContext && matches && item.token) {
        matches.forEach(currentToken => {
            const formmattedCurrentToken = currentToken.replace("[", "").replace("]", "")
            if (formmattedCurrentToken) {
                if (Object.hasOwn(dataContext, formmattedCurrentToken)) {
                    if (dataContext[formmattedCurrentToken] == "ERROR") {
                        previewValue = "ERROR"
                        item.errorValue = true
                    } else {
                        const formatedValue = formatter.format(cleanNumber(dataContext[formmattedCurrentToken]))
                        previewValue = previewValue.replaceAll(currentToken, formatedValue)
                    }
                }
                else {
                    previewValue = previewValue.replaceAll(currentToken, 0)
                }

            }
        })
    } else if (isNumber(item.token)) {
        previewValue = handleThousandFormat(item.token)
    }
    item.previewValue = previewValue
}

export const handleThousandFormat = (number) => {
    if (isNumber(number)) {
        return number.toString().trim().startsWith("$") ? `$${formatter.format(cleanNumber(number))}` : formatter.format(cleanNumber(number))
    }
    return number
}

export const isNumber = (num) => {
    return num && !isNaN(num.toString().replaceAll("$", "").replaceAll(",", ""))
}

export const totalPricingSectionTablePreset = (pricingTable, section) => {
    let total = 0;
    pricingTable.entries.filter(v => v.section === section && v.active && v.name && v.token).forEach(item => {
        const currentValue = item.previewValue ? item.previewValue : 0
        const formattedValue = cleanNumber(isNumber(currentValue) ? currentValue : 0)
        total += formattedValue ? Number(formattedValue) : 0
    })
    return total
}